import React from 'react'
import { Label } from '../Label'
import {
  Slider as AriaSlider,
  SliderOutput,
  SliderProps as AriaSliderProps,
  SliderThumb,
  SliderTrack,
} from 'react-aria-components'

interface SliderProps<T> extends AriaSliderProps<T> {
  label?: string
  showOutput?: boolean
}

export function Slider<T extends number | number[]>({
  label,
  showOutput,
  ...props
}: SliderProps<T>) {
  return (
    <AriaSlider {...props}>
      {label && <Label>{label}</Label>}
      {showOutput && <SliderOutput />}
      <SliderTrack>
        <SliderThumb />
      </SliderTrack>
    </AriaSlider>
  )
}
